var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
export var CloseSmall = function (_a) {
    var props = __rest(_a, []);
    return (_jsx("svg", __assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.15155 7.73734C8.76103 7.34681 8.12786 7.34681 7.73734 7.73734C7.34682 8.12786 7.34682 8.76103 7.73734 9.15155L10.5858 12L7.73734 14.8484C7.34682 15.239 7.34682 15.8721 7.73734 16.2627C8.12786 16.6532 8.76103 16.6532 9.15155 16.2627L12 13.4142L14.8485 16.2627C15.239 16.6532 15.8721 16.6532 16.2627 16.2627C16.6532 15.8721 16.6532 15.239 16.2627 14.8484L13.4142 12L16.2627 9.15155C16.6532 8.76103 16.6532 8.12786 16.2627 7.73734C15.8721 7.34681 15.239 7.34681 14.8484 7.73734L12 10.5858L9.15155 7.73734Z", fill: "currentColor" }) })));
};
